module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      emptypage: _vm.showEmptyPage
    }
  }, [_c('div', {
    class: 'banner site-' + _vm.SITE_CONFIG.site
  }, [_c('div', {
    class: {
      flexer: true
    }
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$t('general.cta.book')) + "\n        "), _c('span', [_vm._v(_vm._s(_vm.$t('general.skirental')))]), (_vm.SITE_CONFIG.skischool.onsite) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.school')))]) : _vm._e(), (_vm.SITE_CONFIG.skischool.onsite) ? _c('span', [_vm._v(", " + _vm._s(_vm.$t('general.skipass')))]) : _vm._e()]), _vm._v(" "), _c('LanguageSwitcher', {
    class: {
      disabled: _vm.loading
    },
    attrs: {
      "type": "row"
    },
    on: {
      "clickedlanguage": _vm.setLoading,
      "pickedlanguage": _vm.pickedLanguage
    }
  }), _vm._v(" "), _c('div', {
    class: {
      buttons: true, show: (_vm.hasPickedLanguage && !_vm.onlySkirental), disabled: _vm.loading
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkirental()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.skirental')))]), _vm._v(" "), (_vm.SITE_CONFIG.skischool.onsite) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkischool()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.school')))]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.skipass.onsite) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.goToSkipass()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.skipass')))]) : _vm._e()])], 1)]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.showEmptyPage || _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c847a1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/OnSitePage.vue
// module id = 970
// module chunks = 0